<template>
  <div>
    <!-- 管理者角色 -->
    <div v-if="HEU_identity === 1" class="board manager">
      <div class="name">
        <span>{{ userInfo.realName }}老师，您好</span>
        <el-dropdown
          trigger="hover"
          :append-to-body="false"
          :show-arrow="false"
        >
          <img
            title="切换身份"
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/52339bef20324785adcfba4e196bd98a.png"
          />

          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="item in roleList"
                :key="item.name"
                @click="changeIdentity(item.role)"
              >
                {{ item.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div
        class="entry"
        onclick="window.open('https://hike-course-homepage.zhihuishu.com/managerCenter/home/')"
      >
        <img
          src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/ac9cd28cee43429aacea4e51886a0470.png"
        />
      </div>
      <div
        class="entry"
        @click="handleLinkTeacherHome"
      >
        <img
          src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/c7c8d8f6dd354419b7a57de1238773f7.png"
        />
      </div>
      <div class="entry-list">
        <!-- 数据中心 -->
        <a
          target="_blank"
          href="https://dch5.zhihuishu.com/newDataCenter.html#/dataOverview?sid=506"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/8165fefa9e6e44688dc139a3aa9bfd64.png"
            alt=""
          />
        </a>
        <!-- 态势大屏 -->
        <a
          target="_blank"
          href="https://dch5.zhihuishu.com/dailyData.html#/dailyData1/mnXPYGVv?sid=506"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/464a40af7bee41dd83894a772f158718.png"
            alt=""
          />
        </a>
        <!-- 教学日报 -->
        <a
          target="_blank"
          href="https://dch5.zhihuishu.com/dailyData.html#/dailyData/mnXPYGVv?VNK=c81fde06"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/e5c91df2a7924b41ad1b3dfd8617b1a0.png"
            alt=""
          />
        </a>
      </div>
    </div>
    <!-- 教师角色 -->
    <div v-else-if="HEU_identity === 2" class="board teacher">
      <div class="name">
        <span>{{ userInfo.realName }}老师，您好</span>
        <el-dropdown
          trigger="hover"
          :append-to-body="false"
          :show-arrow="false"
        >
          <img
            title="切换身份"
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/52339bef20324785adcfba4e196bd98a.png"
          />

          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="item in roleList"
                :key="item.name"
                @click="changeIdentity(item.role)"
              >
                {{ item.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div
        class="entry"
        @click="handleLinkTeacherHome"
      >
        <img
          src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/c7c8d8f6dd354419b7a57de1238773f7.png"
        />
      </div>
      <div class="entry-list">
        <a
          target="_blank"
          href="https://onlineh5.zhihuishu.com/onlineWeb.html#/teachIndex"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/cdd9ae1624b444cfa4079d022625aaf3.png"
            alt=""
          />
          <div>共享课</div>
        </a>
        <a
          target="_blank"
          href="https://hikeweb.zhihuishu.com/hike-tch/resource?type=2"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/697e8f5dc8d449d18dd8eac62ae5cec3.png"
            alt=""
          />
          <div>AI资源库</div>
        </a>
        <a
          target="_blank"
          href="https://hikeh5.zhihuishu.com/resourceCenter/resourceCenter/cloudLibrary"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/c322ff8b2d8248a9bc7cdc95cd24bf78.png"
            alt=""
          />
          <div>资源中心</div>
        </a>
        <a
          target="_blank"
          href="https://hike-course-homepage.zhihuishu.com/goldenCourse"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/33d2e88b1bf940ed8aaf9f2f1d5c373c.png"
            alt=""
          />
          <div>评审主页</div>
        </a>
        <a
          target="_blank"
          href="https://ct.zhihuishu.com/classroomTools/gpFile/home"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/ccbe274261a44ad88f466d95d51d2d27.png"
            alt=""
          />
          <div>群文件管理</div>
        </a>
        <a target="_blank" href="https://hrbeuedu.zhihuishu.com/help">
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/3aed35a7d3004ac4aa36da1f9df8d3e4.png"
            alt=""
          />
          <div>用户指南</div>
        </a>
      </div>
    </div>
    <!-- 学生角色 -->
    <div v-else-if="HEU_identity === 3" class="board student">
      <div class="name">
        <span>{{ userInfo.realName }}同学，您好</span>
        <el-dropdown
          trigger="hover"
          :append-to-body="false"
          :show-arrow="false"
          v-if="server_HEU_identity != 3"
        >
          <img
            title="切换身份"
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/52339bef20324785adcfba4e196bd98a.png"
          />

          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="item in roleList"
                :key="item.name"
                @click="changeIdentity(item.role)"
              >
                {{ item.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div
        class="entry"
        onclick="window.open('https://hike-course-homepage.zhihuishu.com/stu/platformStu')"
      >
        <img
          src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/752f05ffee5c46978de4cb5ba8473181.png"
        />
      </div>
      <div class="entry-list">
        <a
          target="_blank"
          href="https://onlineh5.zhihuishu.com/onlineWeb.html#/studentIndex"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/cdd9ae1624b444cfa4079d022625aaf3.png"
            alt=""
          />
          <div>共享学分课</div>
        </a>
        <a
          target="_blank"
          href="https://ct.zhihuishu.com/classroomTools/gpFile/home"
        >
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/ccbe274261a44ad88f466d95d51d2d27.png"
            alt=""
          />
          <div>群文件管理</div>
        </a>
        <a target="_blank" href="http://doc.livecourse.com/shelp/">
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/3aed35a7d3004ac4aa36da1f9df8d3e4.png"
            alt=""
          />
          <div>用户指南</div>
        </a>
      </div>
    </div>
    <!-- 未登录 -->
    <div v-else class="board un-login">
      <div class="title">教学管理</div>
      <div class="img-wrapper">
        <img
          src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/5cf55ea37fa44b36946723ff0c4590e0.png"
        />
      </div>
      <div class="text">开启智慧教学之旅</div>
      <button
        onclick="window.open('https://hrbeusso.zhihuishu.com/authorize?response_type=code&scope=read&client_id=zhihuishu&portal=1&returi=https://oc.zhihuishu.com/oauth/callback/hrbeu&state=09876999')"
      >
        立即登录
      </button>
    </div>
  </div>
</template>
<script>
import { ElDropdown, ElDropdownMenu, ElDropdownItem } from "element-plus";
export default {
  components: {
    ElDropdown,
    ElDropdownMenu,
    ElDropdownItem,
  },
  created() {
    // 	0:未认证 1:管理者 2:老师 3:学生
    // 加载权限身份
    this.setUserInfo();
  },
  data() {
    return {
      HEU_identity: 0,
      server_HEU_identity: 0,
      userInfo: {},
    };
  },
  computed: {
    roleList() {
      if (this.server_HEU_identity == 1) {
        return  [
            { name: "管理员", role: 1 },
            { name: "教师", role: 2 },
            { name: "学生", role: 3 },
          ];
      } else if (this.server_HEU_identity == 2) {
        return [
            { name: "教师", role: 2 },
            { name: "学生", role: 3 },
          ];
      }
    }
  },
  methods: {
    handleLinkTeacherHome() {
      window.location.href = 'https://hike-course-homepage.zhihuishu.com/tch/EduPlatform'
    },
    async getUserIdentity() {
      try {
        var userInfo = JSON.parse(
          decodeURIComponent(this.$utils.getCookie("CASLOGC"))
        );
        if (userInfo) this.userInfo = userInfo;
      } catch (error) {}
      if (!this.userInfo.uuid || !this.$schoolId) return;
      try {
        const HEU_identity = await this.$http.getUserIdentity({
          uuid: this.userInfo.uuid,
        });
        this.server_HEU_identity = HEU_identity;
        // 	0:未认证 1:管理者 2:老师 3:学生
        if (HEU_identity !== 0) {
          if (+this.$utils.getCookie("HEU_identity")) {
            this.HEU_identity = +this.$utils.getCookie("HEU_identity");
          } else {
            this.HEU_identity = HEU_identity;
            document.cookie = "HEU_identity=" + HEU_identity;
          }
        }
      } catch (error) {
        console.log(error);
        this.getUserIdentity();
      }
    },
    setUserInfo() {
      if (this.$utils.getCookie("CASLOGC")) {
        try {
          let userInfo = JSON.parse(
            decodeURIComponent(this.$utils.getCookie("CASLOGC"))
          );
          if (!userInfo) return;
          this.getUserIdentity();
        } catch (error) {
          console.log(error);
        }
      } else {
      }
    },
    changeIdentity(id) {
      console.log('id', id)
      switch (id) {
        case 1:
          document.cookie = "HEU_identity=1";
          break;
        case 2:
          document.cookie = "HEU_identity=2";
          break;
        case 3:
          document.cookie = "HEU_identity=3";
          break;
        default:
          break;
      }
      window.location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dropdown-menu__item {
    line-height: 25px;
    padding: 3px 15px;
    font-size: 14px;
    color: #7d7d7d;
  }
}

:deep(.el-dropdown-menu__item:not(.is-disabled):hover, .el-dropdown-menu__item:focus) {
  color: #0c3a93;
  background: #fff;
}
</style>
